import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { LayoutGroup } from 'framer-motion';
import './App.css'
import { ThemeProvider } from './lib/theme';

import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import LittersPage from './pages/LittersPage';
import ShowsPage from './pages/ShowsPage';
import OurDogsPage from './pages/OurDogsPage';
import AboutBreedPage from './pages/AboutBreedPage';
import GalleryPage from './pages/GalleryPage';
import ContactPage from './pages/ContactPage';
import DogProfilePage from './pages/DogProfilePage';
import LitterProfilePage from './pages/LitterProfilePage';

// Admin components
import AdminLayout from './admin/AdminLayout';
import LoginPage from './admin/LoginPage';
import DashboardPage from './admin/DashboardPage';
import DogsManagementPage from './admin/DogsManagementPage';
import LittersManagementPage from './admin/pages/LittersManagementPage';
import ShowsManagementPage from './admin/pages/ShowsManagementPage';
import GalleryManagementPage from './admin/pages/GalleryManagementPage';
import ContentManagementPage from './admin/pages/ContentManagementPage';
import SettingsPage from './admin/pages/SettingsPage';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'mioty', element: <LittersPage /> },
      { path: 'mioty/:litterId', element: <LitterProfilePage /> },
      { path: 'wystawy', element: <ShowsPage /> },
      { path: 'nasze-psy', element: <OurDogsPage /> },
      { path: 'nasze-psy/:dogId', element: <DogProfilePage /> },
      { path: 'o-rasie', element: <AboutBreedPage /> },
      { path: 'galeria', element: <GalleryPage /> },
      { path: 'kontakt', element: <ContactPage /> },
    ],
  },
  // Admin routes
  {
    path: '/admin/login',
    element: <LoginPage />
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      {
        index: true,
        element: <DashboardPage />
      },
      {
        path: 'dashboard',
        element: <DashboardPage />
      },
      {
        path: 'dogs',
        element: <DogsManagementPage />
      },
      {
        path: 'litters',
        element: <LittersManagementPage />
      },
      {
        path: 'shows',
        element: <ShowsManagementPage />
      },
      {
        path: 'gallery',
        element: <GalleryManagementPage />
      },
      {
        path: 'content',
        element: <ContentManagementPage />
      },
      {
        path: 'settings',
        element: <SettingsPage />
      },
    ],
  },
]);

function App() {
  return (
    <ThemeProvider>
      <LayoutGroup>
        <RouterProvider router={router} />
      </LayoutGroup>
    </ThemeProvider>
  );
}

export default App
